import styled from "@emotion/styled"
import { Button } from "../../styles/common.styled"
import type { RoomBranding } from "../../../recoil/atoms/room/types"

export interface StylesProps {
  roomStyles?: RoomBranding
  errorMessage?: string
  isError?: string
}

export const Wrapper = styled.div`
  padding: 0rem;
  width: 100%;
  overflow: auto;
`

export const Stack = styled.div`
  display: flex;
`

export const Container = styled.div<StylesProps>`
  padding: 0.5rem;
  border: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBorder
      ? `2px solid ${roomStyles?.servicePanelElementBorder}`
      : "2px solid #ced4da"};
  border-radius: 0.3rem;
  background-color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBackground ?? "white"};
`

export const IncreaseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
`

export const WrapperField = styled.div`
  display: flex;
  margin-bottom: 0.4rem;
  margin-left: 10px;
`

export const AuctionButton = styled(Button)`
  margin-bottom: 0.4rem;
`

export const AuctionTip = styled.p<StylesProps>`
  margin-bottom: 0.4rem;
  width: 62px;
  font-size: 0.875rem;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText ?? "black"};
`

export const SubmitButton = styled(Button)`
  height: 20px;
  width: 80px;
  font-size: 0.8rem;
  margin-left: 1rem;
`

export const WrapperCurrencyInput = styled.div<StylesProps>`
  position: relative;
  > div > input {
    width: 100%;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: ${({ roomStyles }) =>
      roomStyles.servicePanelElementPrimaryText ?? "#495057"};
    background-color: ${({ roomStyles }) =>
      roomStyles.servicePanelElementBackground ?? "#e9ecef"};
    border: ${({ roomStyles, isError }) =>
      isError
        ? roomStyles?.servicePanelElementWarningText
          ? `2px solid ${roomStyles?.servicePanelElementWarningText}`
          : "red"
        : roomStyles.servicePanelElementBorder
        ? `2px solid ${roomStyles.servicePanelElementBorder}b3`
        : "2px solid #ced4da"};
    border-radius: 0.3rem;
    padding: 0.375rem 0.75rem;

    &:hover {
      border-color: ${({ isError, roomStyles }) =>
        isError
          ? roomStyles?.servicePanelElementWarningText ?? "red"
          : roomStyles.servicePanelElementBorder ?? "#CBD5E0"};
    }

    &:focus {
      border-color: ${({ isError, roomStyles }) =>
        isError
          ? roomStyles?.servicePanelElementWarningText ?? "red"
          : roomStyles.servicePanelElementBorder ?? "#718096"};
    }

    &:focus-visible {
      border-color: ${({ isError, roomStyles }) =>
        isError
          ? roomStyles?.servicePanelElementWarningText ?? "red !important"
          : roomStyles.servicePanelElementBackground
          ? `${roomStyles.servicePanelElementBackground} !!!important`
          : "#718096 !!!important"};
      outline: unset;
    }

    ::placeholder {
      color: ${({ roomStyles }) =>
        roomStyles.servicePanelElementPrimaryText ?? "#495057"};
      opacity: 0.5;
    }
  }
  > div > div {
    border: ${({ roomStyles }) =>
      roomStyles?.servicePanelElementBorder
        ? `2px solid ${roomStyles?.servicePanelElementBorder}`
        : "2px solid #ced4da"};
    border-radius: 0.3rem;
    background-color: ${({ roomStyles }) =>
      roomStyles?.servicePanelElementBackground ?? "white"};
  }
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText ?? "black"};
`

export const CurrencyItem = styled.div<StylesProps>`
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText ?? "black"};
  opacity: 0.75;
  &:hover {
    opacity: 1;
  }
`
export const Flag = styled.img`
  display: inline-flex;
  width: 20px;
  vertical-align: middle;
  padding-bottom: 2px;
  margin-right: 7px;
`
